import { defineMessages } from "react-intl";

const messages = defineMessages({
  description: {
    id: "settings.formLayouts.editDefaultValueModal.description",
    defaultMessage:
      "Choose an option below to set it as the default value. When a user creates a record with this layout or variant, <strong>this value will be pre-filled into the field</strong>. Please be aware that users can still modify this value.",
    description: "Description of Default Value modal",
  },
  removeDefault: {
    id: "settings.formLayouts.editDefaultValueModal.remove",
    defaultMessage: "Remove default",
    description: "Title of Default Value modal Remove button",
  },
  saveChanges: {
    id: "settings.formLayouts.editDefaultValueModal.saveChanges",
    defaultMessage: "Save Changes",
    description: "Title of Default Value modal save changes button",
  },
  setDefaultValue: {
    id: "settings.formLayouts.editDefaultValueModal.setValue",
    defaultMessage: "Set default value",
    description: "Title of Default Value modal save button",
  },
  successNotification: {
    id: "settings.formLayouts.editDefaultValueModal.successNotification",
    defaultMessage: "Default value set",
    description: "Default value set success message",
  },
  title: {
    id: "settings.formLayouts.editDefaultValueModal.title",
    defaultMessage: "Default Value",
    description: "Title of Default Value modal",
  },
});

export default messages;
